// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2Mf8l","disabled":"FileBtn_disabled__16CMn","warn":"FileBtn_warn__2T5N_","fade":"FileBtn_fade__1aGcH"};